/************** EVENT PROPERTIES ****************/

export enum GTM_EVENT_NAME {
  SIGN_UP_COMPLETED = "signup-completed",
  PURCHASE = "purchase",
  PAGE_VIEW = "page_view",
  QR_DOWNLOADED = "qr-downloaded",
  QR_CREATED = "qr-created",
  VIEW_ITEM_LIST = "view_item_list",
  ADD_TO_CART = "add_to_cart",
  BEGIN_CHECKOUT = "begin_checkout",
  ADD_SHIPPING_INFO = "add_shipping_info",
  ADD_PAYMENT_INFO = "add_payment_info",
  UNSUBSCRIBE = "unsubscribe",
}

export enum GTM_EVENT_SOURCE {
  MODAL = "sign up modal",
  REGISTER_PAGE = "register page",
}

export enum AMPLITUDE_EVENT_NAME {
  view_landing_home_generator = "view_landing_home_generator",
  view_landing_home = "view_landing_home",
  view_landing_sem = "view_landing_sem",
  view_landing_signup = "view_landing_signup",
  view_landing_login = "view_landing_login",
}

/************** EVENTS INTERFACES ****************/
export interface ViewItemListEventData {
  currency: string;
  items: Array<{
    item_name: string;
    price: number;
    recurrence_price: number;
    quantity: 1;
  }>;
  userEmail: string;
  "user-id": string;
}

export interface ItemEventData {
  value: number;
  currency: string;
  items: Array<{
    item_name: string;
    item_category: "Recurring";
    price: number;
    quantity: 1;
  }>;
  userEmail: string;
  "user-id": string;
}
/************** EVENTS ****************/

export type AMPLITUDE_EVENT = {
  name: AMPLITUDE_EVENT_NAME;
  data?: Record<string, any>;
};

export type GTM_EVENT = {
  event: GTM_EVENT_NAME;
  source?: GTM_EVENT_SOURCE;
  purchase?: Record<string, any>;
  page?: string;
  email?: string;
  "user-id"?: string;
};
